import './CommerceAdOps.scss';
import { useState } from 'react';
import { AlertDialog } from '@Components/AlertDialog';
import { Page } from '@Components/Page';
import { useSetError } from '@src/redux/modals';
import { AdOpsUtilFunctions } from '@Pages/AdOps/adops-constants';
import { AmcInstanceMapping } from './Tools/AmcInstanceMapping';

export const CommerceAdOps = () => {
  const setError = useSetError();
  const [modalMessage, setModalMessage] = useState('');
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  const utils: AdOpsUtilFunctions = { setError, setModalMessage, setShowModalConfirmation };

  return (
    <Page title='Commerce AdOps Tools' pageType='Commerce AdOps Tools'>
      <div className='commerce-ad-ops-row' data-testid='commerce-ad-ops-page'>
        <AmcInstanceMapping utils={utils} />
      </div>
      <AlertDialog
        show={showModalConfirmation}
        onHide={() => setShowModalConfirmation(false)}
        title={modalMessage}
        body=''
        escapable={false}
        passthroughProps={{ 'data-testid': 'commerce-ad-ops-confirmation' }}
      />
    </Page>
  );
};
